import { ProjectMemberRole } from "@prisma/client";
import { TKey } from "@/app/translations/TKey";

export const ROLE_LABEL_KEY: Record<ProjectMemberRole, TKey> = {
  [ProjectMemberRole.OWNER]: TKey.PROJECT_MEMBER_ROLE_OWNER,
  [ProjectMemberRole.ADMIN]: TKey.PROJECT_MEMBER_ROLE_ADMIN,
  [ProjectMemberRole.MEMBER]: TKey.PROJECT_MEMBER_ROLE_MEMBER,
};
